import { render, staticRenderFns } from "./GDS.vue?vue&type=template&id=2e094cd2&scoped=true&"
import script from "./GDS.vue?vue&type=script&lang=js&"
export * from "./GDS.vue?vue&type=script&lang=js&"
import style0 from "./GDS.vue?vue&type=style&index=0&id=2e094cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e094cd2",
  null
  
)

export default component.exports